import React, { Component, Fragment } from "react";
import Auth from "../../services/authService";
import UserProfileService from "../../services/userProfileService";
import LoadingSpinner from "../../components/loader/LoadingSpinner";

import { toast } from "react-toastify";
import "./userInfo.css";
import userImage from "../../assets/images/general/userImage.png";
import razilogo from "../../assets/images/sample/razilogo.png";
import address from "../../assets/images/general/address.png";
import email from "../../assets/images/general/email.png";
import nationalNumber from "../../assets/images/general/nationalNumber.png";
import telNumber from "../../assets/images/general/telNumber.png";
import goldMedal from "../../assets/images/general/goldMedal.png";

const user = Auth.getCurrentUser();

export default class userInfo extends Component {
    state = {
        isLoading: false,
        address: "در حال بارگذاری",
        mobile: "در حال بارگذاری",
        nationalCode: "در حال بارگذاری",
        tel: "در حال بارگذاری",
        email: "در حال بارگذاری",
    };
    async componentDidMount() {
        try {
            const result = await UserProfileService.getUserHmaUserProfile(
                user.nameid
            );
            const state = { ...this.state };
            state.address = result.data.address ? result.data.address : "تعریف نشده";
            state.email = result.data.email ? result.data.email : "تعریف نشده";
            state.mobile = result.data.mobile ? result.data.mobile : "تعریف نشده";
            state.nationalCode = result.data.nationalCode ? result.data.nationalCode : "تعریف نشده";
            state.tel = result.data.tel ? result.data.tel : "تعریف نشده";
            const isLoading = true;
            state.isLoading = isLoading;
            this.setState(state);
        } catch (ex) {
            if (ex.code !== "ERR_NETWORK") {
                if (ex.code !== "ERR_BAD_REQUEST")
                    toast.error(ex.response.data.Message);
            }
        }
    }

    render() {
        return (
            <Fragment>
                <div className="main-wrapper">
                    <div className="up-half">
                        <div className="justify-content-md-center align-items-center">
                            {user.customerid !== "22948" && (
                                <img src={userImage} className="customerIcon" alt="logo" />
                            )}
                            {user.customerid === "22948" && (
                                <img src={razilogo} className="customerIcon" alt="logo" />
                            )}

                            <div className="customerName">
                                {user.unique_name}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-1" />
                        <div className="col-10">
                            <div className="extraInfo-Card">
                                <div className="row">
                                    <div className="col-4 extraInfo">امتیاز</div>
                                    <div className="col-4 extraInfo">باشگاه مشتریان</div>
                                    <div className="col-4 extraInfo">تعداد خرید</div>
                                </div>
                                <div className="row">
                                    <div className="col-4 extraInfo extraInfo-detail">۱۰۲</div>
                                    <div className="col-4 extraInfo extraInfo-detail"><img src={goldMedal} className="goldMedal" alt="goldMedal" /></div>
                                    <div className="col-4 extraInfo extraInfo-detail">۳</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-1" />
                    </div>
                    <div className="down-half">
                        <div className="row downSec">
                            <div className="row ">
                                <div className="col-1" />
                                <div className="col-2">
                                    <img src={email} className="imageIcon" alt="email" />
                                </div>
                                <div className="col-9" >
                                    <div className="itemDetails">
                                        {this.state.email}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row downSec">
                            <div className="row ">
                                <div className="col-1" />
                                <div className="col-2">
                                    <img src={address} className="imageIcon" alt="address" />
                                </div>
                                <div className="col-9" >
                                    <div className="itemDetails">
                                        {this.state.address}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row downSec">
                            <div className="row ">
                                <div className="col-1" />
                                <div className="col-2">
                                    <img src={nationalNumber} className="imageIcon" alt="nationalNumber" />
                                </div>
                                <div className="col-9" >
                                    <div className="itemDetails justify-content-md-center align-items-center">
                                        {this.state.nationalCode}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row downSec">
                            <div className="row ">
                                <div className="col-1" />
                                <div className="col-2">
                                    <img src={telNumber} className="imageIcon" alt="telNumber" />
                                </div>
                                <div className="col-9" >
                                    <div className="itemDetails">
                                        {this.state.tel}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
        );
    }
}
